var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-star.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8018 5.85296C12.7651 5.74497 12.6976 5.65007 12.6076 5.57999C12.5177 5.50992 12.4091 5.46773 12.2954 5.45863L8.96986 5.19438L7.53078 2.00879C7.48495 1.90619 7.4104 1.81905 7.31614 1.75788C7.22188 1.69671 7.11193 1.66412 6.99955 1.66406C6.88718 1.664 6.77719 1.69646 6.68286 1.75753C6.58853 1.8186 6.51389 1.90566 6.46795 2.00821L5.02886 5.19438L1.70328 5.45863C1.59155 5.46748 1.48473 5.50833 1.3956 5.5763C1.30648 5.64427 1.23883 5.73648 1.20074 5.84189C1.16264 5.94731 1.15573 6.06146 1.18082 6.1707C1.2059 6.27994 1.26193 6.37964 1.3422 6.45788L3.79978 8.85363L2.93061 12.6173C2.90422 12.7312 2.91268 12.8504 2.95489 12.9595C2.9971 13.0686 3.07112 13.1624 3.16733 13.2289C3.26355 13.2954 3.37752 13.3314 3.49445 13.3323C3.61139 13.3331 3.7259 13.2989 3.82311 13.2339L6.99936 11.1164L10.1756 13.2339C10.275 13.2998 10.3922 13.3338 10.5114 13.3312C10.6306 13.3286 10.7462 13.2895 10.8426 13.2192C10.939 13.149 11.0115 13.0509 11.0505 12.9382C11.0894 12.8254 11.0929 12.7035 11.0605 12.5887L9.99361 8.85538L12.6396 6.47421C12.8129 6.31788 12.8764 6.07404 12.8018 5.85296Z",
    fill: "#FF8514"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsStar);
export default __webpack_public_path__ + "static/media/bxs-star.81fce23bb5f706bd3d3a4482e64b4307.svg";
export { ForwardRef as ReactComponent };